import React from 'react';
import { Container } from './Container';

interface SectionWrapperProps {
  children: React.ReactNode;
  className?: string;
  containerClassName?: string;
  id?: string;
  bg?: 'default' | 'white' | 'dark' | 'green';
  py?: 'sm' | 'md' | 'lg' | 'xl';
}

const bgMap = {
  default: 'bg-v2-bg',
  white:   'bg-v2-neutral-0',
  dark:    'bg-v2-neutral-900',
  green:   'bg-v2-green-500',
};

const pyMap = {
  sm: 'py-10',
  md: 'py-16',
  lg: 'py-20',
  xl: 'py-24',
};

export const SectionWrapper: React.FC<SectionWrapperProps> = ({
  children,
  className = '',
  containerClassName = '',
  id,
  bg = 'default',
  py = 'lg',
}) => (
  <section id={id} className={`${bgMap[bg]} ${pyMap[py]} ${className}`}>
    <Container className={containerClassName}>
      {children}
    </Container>
  </section>
);

interface SectionHeadingProps {
  label?: string;
  title: string;
  description?: string;
  align?: 'left' | 'center';
  dark?: boolean;
}

export const SectionHeading: React.FC<SectionHeadingProps> = ({
  label,
  title,
  description,
  align = 'center',
  dark,
}) => (
  <div className={`mb-10 ${align === 'center' ? 'text-center' : ''}`}>
    {label && (
      <p className={`font-mono text-[10px] font-medium uppercase tracking-[0.14em] mb-2 ${dark ? 'text-v2-green-300' : 'text-v2-green-500'}`}>
        {label}
      </p>
    )}
    <h2 className={`font-display text-[30px] font-bold tracking-[-0.02em] leading-[1.1] ${dark ? 'text-white' : 'text-v2-neutral-900'}`}>
      {title}
    </h2>
    {description && (
      <p className={`mt-2 text-[15px] leading-[1.6] max-w-[640px] ${align === 'center' ? 'mx-auto' : ''} ${dark ? 'text-v2-neutral-400' : 'text-v2-neutral-500'}`}>
        {description}
      </p>
    )}
  </div>
);
